<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      {{doing}}のお願い
      <v-spacer/>
      <v-icon @click="closeDialog()">close</v-icon>
    </v-card-title>
    <v-card-text>
      {{items}}
      <v-alert :value="true" color="info" icon="info" outline>上司を追加して{{doing}}をお願いしてください。</v-alert>
      <loading :isLoading="isLoading"/>
      <v-container grid-list-md fluid>
        <v-layout row　align-center>
          <v-flex md3>
            <v-text-field
              v-model="name"
              :rules="[rules.required, rules.counter]"
              label="名前"
              counter
              maxlength="10"
            ></v-text-field>
          </v-flex>
          <v-flex md4>
            <v-text-field v-model="email" :rules="[rules.required, rules.email]" label="E-mail"></v-text-field>
          </v-flex>
          <v-flex md2>
            <v-btn @click.stop="openSendMail()" v-if="status=='approving'">
              <v-icon>email</v-icon>承認
            </v-btn>
            <v-btn @click.stop="openSendMail()" v-if="status=='rating'">
              <v-icon>email</v-icon>評価
            </v-btn>
          </v-flex>
        </v-layout>
        <v-alert :value="isSuccess" type="success">メールを送信しました</v-alert>
        <v-alert :value="errorMessage.length>0">{{errorMessage}}</v-alert>
        <v-dialog v-model="showSendMail" max-width="80%">
          <v-card>
            <v-card-title class="headline">{{doing}}のお願いメール送信</v-card-title>

            <v-card-text>
              <v-text-field label="件名" v-model="mailSubject"></v-text-field>
              <v-textarea v-model="mailBody" label="本文" auto-grow></v-textarea>
            </v-card-text>

            <v-card-actions>
              <v-btn color="green darken-1" flat="flat" @click="sendMail()">送信</v-btn>

              <v-btn color="green darken-1" flat="flat" @click="showSendMail = false">閉じる</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn @click="closeDialog()">閉じる</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "@/components/firebaseInit";
import Loading from "@/components/loading.vue";
import { crudErrorCodeToMessage } from "@/utils/errorMessages.js";
import { getUnixtime } from "@/utils/datetime.js";
export default {
  props: {
    status: {
      type: String,
      default: "approving"
    },
    userName: {
      type: String,
      default: "対象者"
    },
    permissionDic: {
      type: Object,
      default: null
    }
  },
  components: { Loading },
  data() {
    return {
      headers: [
        { text: "名前", value: "name", sortable: false },
        { text: "email", value: "email", sortable: false },
        { text: "操作", sortable: false }
      ],
      mailDbRef: db.collection("mails"),
      dbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("challenge_sheets")
        .doc(this.$route.params.sheet_id)
        .collection("raters"),
      items: [],
      name: "",
      email: "",
      rules: {
        required: value => !!value || "必須",
        counter: value => value.length <= 10 || "最大10文字まで",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "E-mailの形式ではありません。";
        }
      },
      isLoading: false,
      errorMessage: "",
      mailSubject: "",
      mailBody: "",
      toAdress: "",
      showSendMail: false,
      isSuccess:false,
    };
  },
  computed: {
    doing() {
      return this.status == "approving" ? "承認" : "評価";
    },
    url() {
      return (
        window.location.origin +
        "/" +
        this.$router.resolve({
          name: "target",
          params: {
            company_id: this.$route.params.company_id,
            sheet_id: this.$route.params.sheet_id
          },
          query: { p: this.permissionDic[this.status] }
        }).href
      );
    }
  },
  mounted() {
    //this.reloadItems();
  },
  methods: {
    async reloadItems() {
      this.isLoading = true;
      this.items = [];
      const items = await this.dbRef.get();
      items.forEach(doc => {
        this.items.push({ ...doc.data(), id: doc.id });
      }, this);
      this.isLoading = false;
    },
    closeDialog() {
      this.isSuccess = false;
      this.$emit("closeDialog");
    },
    clearItem() {
      this.email = "";
      this.name = "";
    },
    async deleteItem(item) {
      try {
        await this.dbRef.doc(item.id).delete();
        this.reloadItems();
      } catch (e) {
        this.errorMessage = crudErrorCodeToMessage(e.code);
        console.error(e);
      }
    },
    async sendMail() {
      const mail = {};
      mail.subject = this.mailSubject;
      mail.body = this.mailBody;
      mail.to = this.toAdress;
      mail.sending_time = getUnixtime();
      mail.was_sent = false;
      mail.company_id = this.$route.params.company_id;
      try {
        const docRef = await this.mailDbRef.add(mail);
        this.isSuccess = true;
        this.showSendMail = false;
      } catch (e) {
        this.isSuccess = false;
        this.errorMessage = "メールの送信に失敗しました。";
        this.showSendMail = false;
        console.error(e);
      }
    },
    openSendMail() {
      this.toAdress = this.email;
      this.mailSubject =
        this.userName + "様改革プラン" + this.doing + "のお願い";
      this.mailBody =
        this.name +
        " 様 \r\n\r\n" +
        this.userName +
        "様の改革プラン" +
        this.doing +
        "のお願いのためメール致しました。\r\n下記URLよりお願いいたします。\r\n\r\n";
      this.mailBody = this.mailBody + this.url;
      this.showSendMail = true;
    }
  }
};
</script>
